
export class GetSignWorkByCompanyInputDto {
    startDate: Date;
    finishDate: Date;
    userIds: string[];
    companyIds: string[];
    itemPerPage: number;
    page: number;
}
